<template>
  <div
    class="portfolio-modal modal fade"
    id="portfolioModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close-modal" data-dismiss="modal" @click="clearProject">
          <img src="../assets/img/close-icon.svg" alt="Close modal" />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div class="modal-body" v-if="project.isLoading">
                <ContentLoader />
              </div>

              <div class="modal-body" v-else>
                <!-- Project Details Go Here-->
                <h2 class="text-uppercase">{{ project.company.name }}</h2>
                <p class="item-intro text-muted">
                  {{ project.name }}
                </p>
                <div
                  id="carouselExampleIndicators"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div
                      class="carousel-item"
                      v-for="(carousel, index) in project.carousels"
                      :key="carousel.id"
                      :class="index === 0 ? 'active' : ''"
                    >
                      <img
                        class="d-block w-100"
                        :src="require(`@/${carousel.imageUrl}`)"
                        :alt="`${index} slide`"
                      />
                    </div>
                  </div>
                  <a
                    class="carousel-control-prev"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
                <p v-html="project.description" class="ml-4 mr-4"></p>
                <ul class="list-inline">
                  <!-- <li>Date: {{ project.date }}</li> -->
                  <li>Client: {{ project.client }}</li>
                  <li>Category: {{ project.category }}</li>
                </ul>
                <button
                  class="btn btn-primary"
                  data-dismiss="modal"
                  type="button"
                  @click="clearProject"
                >
                  <i class="fas fa-times mr-1"></i>
                  Close Project
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ContentLoader } from "vue-content-loader";

export default {
  components: { ContentLoader },
  computed: mapGetters(["project"]),
  methods: mapActions(["clearProject"]),
};
</script>
